export const MODELS_FETCHING_ERROR_PREFIX = 'Failed to fetch models';
